<report-page [footer]="true" class="landscape">
    <div class="full-height full-width flex-column">
        <div class="full-width">
            <div class="strip bar-1"></div>
        </div>
        <div class="flex-row justify height-10">
            <div class="full-width flex-row middle">
                <p class="font-large"><strong>Report Time Interval : </strong></p>
            </div>
            <div class="full-width flex-row middle">
                <p class="font-large"><strong>Begin: </strong>{{startDate|date:'medium'}}</p>
            </div>
            <div class="full-width flex-row middle">
                <p class="font-large"><strong>End: </strong>{{endDate|date:'medium'}}</p>
            </div>
        </div>
        <div class="flex-row justify height-10">
            <div class="full-width flex-row middle">
                <p class="font-large mt-0 mb-0"><strong> Up Time: </strong> {{totalUpTime}} ({{efficiency.toFixed(2)}}%)</p>
            </div>
            <div class="full-width flex-row middle">
                <p class="font-large"><strong>Belt Off Time: </strong>{{offBeltDuration}} ({{beltOffPercentage}}%)</p>
            </div>
            <div class="full-width flex-row middle">
                <p class="font-large"><strong>Black Belt Time: </strong>{{blackBeltDuration}} ({{blackBeltPercentage}}%)</p>
            </div>
        </div>
        <div *ngIf="(chartType$ | async) === 'line'">
            <figure *ngIf="(chartLines$ | async)" class="highcharts-figure full-width">
                <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts" [constructorType]="'stockChart'"
                    [options]="chartLines$|async">
                </highcharts-chart>
            </figure>
        </div>
        <div *ngIf="(chartType$ | async) === 'series'">
            <figure *ngIf="(chartLines$ | async)" class="highcharts-figure full-width">
                <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts" [constructorType]="'stockChart'"
                    [options]="chartSeries$|async">
                </highcharts-chart>
            </figure>
        </div>
        <div class="full-width">
            <div class="strip bar-1"></div>
            <div class="strip"></div>
            <div class="strip"></div>
        </div>
    </div>
</report-page>